// @ts-nocheck
import { Modal, Box, Typography, Button } from "@mui/material";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../../../utils/styles/getCssVariables";

// NOTE: style for modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 4,
  minWidth: "700px",
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  "@media (max-width: 600px)": {
    minWidth: "96vw",
    maxHeight: "96vh",
    width: "97vw",
    overflowY: "auto",
  },
};

const consent = [
  {
    heading: "Why We Send SMS:",
    message:
      "You will receive SMS updates related to your account, event schedule, and important service notifications. These may include booking confirmations, schedule changes, login credentials, support messages, or time-sensitive alerts.",
  },
  {
    heading: "Message Frequency:",
    message:
      "Message frequency may vary depending on your usage of the ShowPhaze platform.",
  },
  {
    heading: "Consent and Charges:",
    message:
      "By opting in, you confirm that you are the owner of the provided phone number and agree to receive text messages from ShowPhaze. Standard message and data rates may apply as per your carrier plan.",
  },
  {
    heading: "Opting Out:",
    message:
      "Reply STOP to unsubscribe from SMS updates at any time. You will receive no further messages unless you re-subscribe.",
  },
  {
    heading: "Getting Help:",
    message:
      "Reply HELP to get support info via SMS, or contact us at [support email/phone].",
  },
  {
    heading: "Re-subscribing:",
    message:
      "To re-enable SMS after opting out, reply START to a previous message or contact support.",
  },
];

export const SMSConsentModal = ({ open, handleClose }) => {
  function onClose() {
    handleClose();
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ ...style }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Typography fontSize={"1.5rem"} fontWeight={500}>
            SMS Consent Terms – ShowPhaze
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              flexDirection: "column",
              gap: "0.75rem",
            }}
          >
            {consent?.map((item, i) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    gap: "0.25rem",
                  }}
                  key={`consent-${i}`}
                >
                  <Typography
                    sx={{
                      fontSize: "1.15rem",
                      fontWeight: "500",
                      color: getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      }),
                    }}
                  >
                    {item?.heading}
                  </Typography>
                  <Typography>{item?.message}</Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
        <Box className="bottom-btn-box">
          <Button className="btn-black" onClick={handleClose}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

SMSConsentModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};